import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadAssets = async () => {
  let response = await Axois.get('/assets').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
}


export const loadAccountAndSetup = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/asset');
        const responseData = await requests.data;
        return {...responseData, asset: {}};
      
      default:
        let response = await Axois.get('/assets/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}



const useAssetAPI = () => {
  
  const saveAsset = async (data, success) => {
    try {
      const response = await Axois.post('/assets', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('saveAssetResponse', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };


  const updateAssetStatus = async (seo, status, success) => {
    try {
      const response = await Axois.patch('/assets/'+seo, {status: status});
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('updateStatusAssetResponse', {status: status});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/assets/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('saveAssetResponse', {status: 'draft', seo: data.seo});
    }catch (err) {
      console.log(err);
    }
  }

  return { saveAsset, updateAssetStatus, update };
}


export default useAssetAPI;